
import { makeRequest } from '../../../../lib/api';
import {
  GetOrderInvoicesRequest,
  CreateOrderInvoiceRequest,
  SendInvoiceToSmsRequest,
  ManageInvoiceRequest,
  GetQRCodeRequest,
  SendSmsWithBonusRequest,
  CreateInvoiceAutomatedRequest,
  tBankHoldRequest,tBankRefundRequest,
} from '../../api/invoiceApi';

import {
  EditOrderInvoiceRequest,
} from './invoicesStore';

const ORDER_INVOICES_PATH = '/v1/order_invoices';
const ORDER_INVOICES_V2_PATH = '/v2/order_invoices';
const PARTNER_LEGAL_USER = '/v1/order_invoices/partner_legal_user'; // юр.лица пользователя

const invoiceController = {
  getOrderInvoices: (request: GetOrderInvoicesRequest): Promise<any> => {
    return makeRequest('get', `${ ORDER_INVOICES_PATH }?orderId=${ request.orderId }&showDeleted=${ request.showDeleted || false }`);
  },
  getOrderInvoice: (id: string): Promise<any> => {
    return makeRequest('get', `${ ORDER_INVOICES_PATH }/${ id }`);
  },
  createInvoice: (request: CreateOrderInvoiceRequest): Promise<any> => {
    return makeRequest('post', ORDER_INVOICES_PATH, request);
  },
  editInvoice: (id: string, request: EditOrderInvoiceRequest): Promise<any> => {
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }`, request);
  },
  deleteInvoice: (id: string): Promise<any> => {
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }/deactivate`);
  },
  restoreInvoice: (id: string): Promise<any> => {
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }/activate`);
  },
  sendInvoice: (id: string, sendSms = true): Promise<any> => {
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }/send?sendPush=${ sendSms ? 'true' : false }`);
  },
  acceptInvoice: (id: string): Promise<any> => {
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }/accept`);
  },

  // далее метод, которые помечает счёт "Принятым клиентов", чтоб по СМС можно было отправить ссылку на оплату
  // этот метод нужен для случаев когда у клиента нет прилаги, но хочет оплатить счёт безналом
  sendInvoiceToSms: (id: string, data:SendInvoiceToSmsRequest): Promise<any> => {
    const ph = data.phone ? `?phone=${ data.phone }` : '';
    // return makeRequest('post', `${ ORDER_INVOICES_PATH }/${ id }/payments/card${ ph }`);

    return makeRequest('post', `${ ORDER_INVOICES_V2_PATH }/${ id }/payments/webview${ ph }`);
  },
  closeInvoice: (id: string): Promise<any> => {
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }/close`);
  },
  reformInvoice: (id: string): Promise<any> => {
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }/reform`);
  },
  revokeInvoice: (id: string): Promise<any> => {
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }/revoke`);
  },
  payInCashInvoice: (id: string, viaTerminal = false, bonusToSpend: number, sms:string): Promise<any> => {
    const viaTerminalStr = viaTerminal ? '?viaTerminal=true' : '?viaTerminal=false';
    const bonusToSpendStr = bonusToSpend ? `&bonusToSpend=${ bonusToSpend }` : '';
    const smsStr = sms &&(typeof sms ==='string') ? `&smsCode=${ sms }` : '';
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }/pay/in_cash${ viaTerminalStr }${ bonusToSpendStr }${ smsStr }`);
  },
  payToAccountInvoice: (id: string): Promise<any> => {
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }/pay/to_account`);
  },
  // Подтвердить для указанного счёта приход безналичной оплаты на расчётный счёт, в т.ч. перевести
  // его из состояния 'Оплачен по счёту (ожидаем поступления денег на счёт)' в состояние 'Оплачен клиентом'
  affirmPaidToAccount: (id: string): Promise<any> => {
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }/affirm_paid_to_account`);
  },
  getOrderInvoicePositions: (id: string): Promise<any> => {
    return makeRequest('get', `${ ORDER_INVOICES_PATH }/${ id }/positions`);
  },
  retractLastPaymentInInvoice: (id: string): Promise<any> => {
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }/retract`);
  },
  // автоматически заполняем юр.лицо при оформлении счёта, привязанное к исполнителю к указанному сервису
  // функция ниже только достаёт это юр.лицо из базы
  // немного не логично смотрит размещение тут этой функции, но она только и нужна в счёте, больше нигде не используется (на 23.10.2021)
  getPartnerLegalUser: (data) => {
    return makeRequest('get', `${ PARTNER_LEGAL_USER }/partner_legal?serviceId=${ data.serviceId }&userId=${ data.userId }`);
  },

  // операции с мультиплатежами
  // блокируем деньги
  tBankHoldPaymentInInvoice: (id: string, request: tBankHoldRequest ): Promise<any> => {
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/payments/${ id }/tbank_payout/hold`, request);
  },

  // снимаем блокировку деньги
  tBankUnHoldPaymentInInvoice: (id: string): Promise<any> => {
    return makeRequest('delete', `${ ORDER_INVOICES_PATH }/payments/${ id }/tbank_payout/hold`);
  },

  // пропускаем суточное ожидание перед выплатой
  tBankSkipWaitPaymentInInvoice: (id: string, request: tBankHoldRequest): Promise<any> => {
    return makeRequest('post', `${ ORDER_INVOICES_PATH }/payments/${ id }/tbank_payout/skip_wait`, request);
  },

  // всё на счёт автоапп 
  tBankPaymentRedirectToAvtoapp: (id: string): Promise<any> => {
    return makeRequest('post', `${ ORDER_INVOICES_PATH }/payments/${ id }/tbank_payout/redirect_to_avtoapp`);
  },

  // возвращаем деньги
  tBankReturnMoneyPaymentInInvoice: (id: string, request: tBankRefundRequest): Promise<any> => {
    return makeRequest('post', `${ ORDER_INVOICES_PATH }/payments/${ id }/refund`, request);
  },
  // конец операций с мультиплатежами Т-Банка

  // функция полностью автоматического создания счёта:
  createInvoiceAutomated: (request: CreateInvoiceAutomatedRequest): Promise<any> => {
    const onlyFirstFill = request?.onlyFirstFill ? '?onlyFirstFill=true' : '';
    return makeRequest('post', `${ ORDER_INVOICES_PATH }/automated${ onlyFirstFill }`, request);
  },

  // функция создания счёта с предзаполнение (концепт новго дизайна 2025):
  createInvoiceAutofill: (orderId: string): Promise<any> => {
    return makeRequest('post', `${ ORDER_INVOICES_PATH }/autofill`, { orderId });
  },

  manageInvoice: (id: string, request: ManageInvoiceRequest): Promise<any> => {
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }/crucial`, request);
  },

  getQrCode: (request: GetQRCodeRequest): Promise<any> => {
    // qrDataType=IMAGE: в qrCode вернётся готовая SVG-картинка QR-кода (base64),
    // а не ссылка СБП — её показываем клиенту для сканирования с любого устройства
    return makeRequest('post', `${ ORDER_INVOICES_PATH }/${ request.id }/payments/sbp_api?qrDataType=IMAGE`, { bonusToSpend: request.bonusToSpend });
  },

  sendSmsWithBonus: (request: SendSmsWithBonusRequest): Promise<any> => {
    return makeRequest('post', `${ ORDER_INVOICES_PATH }/${ request.orderInvoiceId }/send/sms?bonusToSpend=${ request.bonusToSpend }`);
  },

};

export { invoiceController };
